import { CheckOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import RegistrationPlanInfoDialog from "../Dialogs/RegistrationPlanInfoDialog";
import { DialogComponent } from "./../common/DialogComponent";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { EnrollNowPath } from "../../util/enrollPath";
import { useTranslation } from "react-i18next";
import WhatYouNeedToKnow from "./../common/WhatYouNeedToKnow";
import { IPackage, IProduct } from "../../store/protectionPlanService/ezs/types";
import { CheckNonCreditServicesForNCDisclaimer } from "../Dialogs/protectionPlan/NonCreditServicesForNCDisclaimer";

interface IProps {
    displayData: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
    saleTaxValue?: number;
    annualSalesTaxValue?: number;
    selectedCountry?: string;
    creditDisclosureText?: string;
    getproductServiceType?: any;
    NonCreditServiceType?: any;
}
const Cart = ({ displayData, registrationState, setRegistrationState, registrationLookup, saleTaxValue, annualSalesTaxValue, selectedCountry, creditDisclosureText, getproductServiceType, NonCreditServiceType }: IProps) => {
    const { t: tLang } = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get("RetailerCode") || query.get("RETAILERCODE");
    const LookupType = query.get("Type");
    const SubType = query.get("SUBTYPE");
    const [isAutoSubmit, setAutoSubmit] = useState(!!query.get("AUTOSUBMIT") ? query.get("AUTOSUBMIT") : false);
    const [isCredit, setIsCredit] = useState(false);
    const [istermExiprationVisible, setTermExiprationVisible] = useState(false);
    const isEBpartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 542
                ? true
                : false
            : false
    );

    const isTUVIP = useSelector((state: ApplicationState) =>
        RetailerCode && state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2649 && RetailerCode === "tuvip"
                ? true
                : false
            : false
    );
    const [cycle, setCycle] = useState({
        selectedCycle: registrationState.PaymentMode.SubscriptionType
            ? registrationState.PaymentMode.SubscriptionType
            : SubType === "ANNUAL"
                ? "annual"
                : "monthly",
    });
    let updateEndDateOnRegistration: boolean = displayData["registrationCodeDetails"] && displayData["registrationCodeDetails"]["updateEndDateOnRegistration"];
    let termExpirationServiceDuration: string = displayData["registrationCodeDetails"] && displayData["registrationCodeDetails"]["serviceDuration"];
    const billingOptions = displayData["billingOptions"] && displayData["billingOptions"];
    const packageDetails = displayData["packageLookup"] && displayData["packageLookup"]["packagDetails"][0];
    const idfOfferLookup = registrationLookup && registrationLookup["idfOfferLookup"] && registrationLookup["idfOfferLookup"];
    const isReachpartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2560
                ? true
                : false
            : false
    );

    const showTuvipTermExp = () => {
        if (isTUVIP && updateEndDateOnRegistration && termExpirationServiceDuration) {
            setTermExiprationVisible(true);
        }
    };

    const isCyberscoutInsuPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 1557
                ? true
                : false
            : false
    );
    const isGuardWell = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2601
                ? true
                : false
            : false
    );
    const isGuardWellPremier = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2604
                ? true
                : false
            : false
    );
    const isGuardWellDiscount = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2606
                ? true
                : false
            : false
    );
    const isAmfam = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2608
                ? true
                : false
            : false
    );
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    const [serviceListOfSelectedPackage, setServiceListOfSelectedPackage]: any = useState([""]);
    const [dialog, setDialog] = useState(false);
    const handleCloseDialog = (): any => {
        setDialog(false);
    };

    const enrollNowPathURL = EnrollNowPath();

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    const setBillingCycle = (type: any) => {
        setCycle({ selectedCycle: type });
        const PaymentMode = { SubscriptionType: type };
        setRegistrationState({ ...registrationState, PaymentMode: PaymentMode });
    };

    const getPackageOrOfferName = () => {
        if (packageDetails && packageDetails["packageName"]) {
            return packageDetails["packageName"];
        }
        if (idfOfferLookup && idfOfferLookup["offerName"]) {
            return idfOfferLookup["offerName"];
        }
    };

    const showDisclosureStatus = (value: boolean) => {
        if (value) {
            setIsCredit(true);
        }
        if (getproductServiceType) {
            getproductServiceType(value)
        }
    };

    useEffect(() => {
        if (packageDetails) {
            let productNames = [] as string[];
            let packageServiceslst = packageDetails["packageServiceslst"] as [];

            for (var i = 0; i < packageServiceslst.length; i++) {
                let srvc = packageServiceslst[i];
                let productName = srvc["productName"];
                if (productName != null && productName != "" && productName != "--") {
                    productNames.push(productName);
                }
            }

            setServiceListOfSelectedPackage(productNames);
        }
    }, [packageDetails]);

    const checkNonCreditServiceAvailable = () => {
        let result: string = "";
        if (!isCredit) {
            result = CheckNonCreditServicesForNCDisclaimer(serviceListOfSelectedPackage);
        }
        return result;
    };

    useEffect(() => {
        let checkNonCredit: string = checkNonCreditServiceAvailable()
        if (checkNonCredit) {
            if (NonCreditServiceType) {
                NonCreditServiceType(checkNonCredit);
            }
        }

    }, [isCredit === false, showDisclosureStatus]);

    useEffect(() => {
        showTuvipTermExp();
    }, []);

    return (
        <>
            <div className="col-xs-12 col-sm-1 col-no-gutter">&nbsp;</div>
            <div className="col-xs-12 col-sm-4 col-no-gutter">
                <div id="shopping-cart" className="shopping-cart">
                    <div className={`shopping-cart-new ${!isWhiteLabeled ? "cart-border" : ""}`}>
                        <div className="shopping-cart-header">
                            <h3 className="content-sub-title sr-only">Your Cart</h3>
                        </div>
                        <div className="shopping-cart-plan">
                            <h4 className="your-title" id="plan-title">
                                {tLang("registration.plan.your-plan")}:
                            </h4>

                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter">
                                    <span>{getPackageOrOfferName()}</span>
                                </div>
                                {!isAutoSubmit && (
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        {LookupType === "WALKUP" && (
                                            <a onClick={() => window.addToDataLayer({ event: "Change" })} href={enrollNowPathURL} className="default_link">
                                                {tLang("registration.plan.changeLinkText")}
                                                <span className="sr-only">selected plan</span>
                                            </a>
                                        )}
                                        {LookupType === "SSSOFFER" && !isGuardWell && !isGuardWellDiscount && !isAmfam && (
                                            <a
                                                onClick={() => {
                                                    window.addToDataLayer({ event: "Change" });
                                                    window.history.back();
                                                }}
                                                href="javascript:void(0)"
                                                className="default_link"
                                            >
                                                {tLang("registration.plan.changeLinkText")}
                                                <span className="sr-only">selected plan</span>
                                            </a>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="offset-padding">
                                <WhatYouNeedToKnow serviceList={serviceListOfSelectedPackage} selectedCountry={selectedCountry} showDisclosureStatus={showDisclosureStatus} wyntkCss={true} isWhiteLabel={isWhiteLabeled} />
                            </div>
                            {packageDetails && displayData.billingRequired && (
                                <div className="shopping-cart-footer shopping-cart-footer-new">
                                    <div className="row between-xs shopping-cart-title" id="total-cost">
                                        <div className="col-xs col-no-gutter your-title">
                                            {LookupType == "WALKUP" && !saleTaxValue ? tLang("registration.plan.identity-protection-cost") : tLang("registration.plan.identity-protection-cost")}:
                                        </div>

                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            {SubType && saleTaxValue ? (
                                                <span id="total-cost-value">
                                                    {packageDetails && cycle.selectedCycle == "annual"
                                                        ? annualSalesTaxValue
                                                            ? formatter.format(parseFloat(packageDetails.yearlySubscriptionPrice) + annualSalesTaxValue)
                                                            : formatter.format(packageDetails.yearlySubscriptionPrice)
                                                        : packageDetails && formatter.format(parseFloat(packageDetails.monthlySubscriptionPrice) + saleTaxValue)}
                                                    /
                                                    <abbr title="monthly">
                                                        {packageDetails && cycle.selectedCycle == "annual"
                                                            ? tLang("registration.plan.perYearText")
                                                            : tLang("registration.plan.perMonthText")}
                                                    </abbr>
                                                </span>
                                            ) : (SubType &&
                                                <span id="total-cost-value">
                                                    {packageDetails && cycle.selectedCycle == "annual"
                                                        ? formatter.format(packageDetails.yearlySubscriptionPrice)
                                                        : packageDetails && formatter.format(packageDetails.monthlySubscriptionPrice)}
                                                    /
                                                    <abbr title="monthly">
                                                        {packageDetails && cycle.selectedCycle == "annual"
                                                            ? tLang("registration.plan.perYearText")
                                                            : tLang("registration.plan.perMonthText")}
                                                    </abbr>
                                                </span>
                                            )}
                                            {LookupType == "WALKUP" && cycle.selectedCycle === "annual" && !saleTaxValue && (
                                                <>
                                                    <div className="col-xs col-no-gutter flex-grow-null">
                                                        <span id="total-strike-cost-value">
                                                            {formatter.format(packageDetails.monthlySubscriptionPrice * 12)}/
                                                            <abbr title="monthly">{tLang("registration.plan.perYearText")}</abbr>
                                                        </span>
                                                    </div>

                                                    <div className="margin-bottom-xs"></div>
                                                </>
                                            )}
                                            {LookupType !== "SSSOFFER" && LookupType !== "WALKUP" && packageDetails && displayData.billingRequired && (
                                                <div className="shopping-cart-footer">
                                                    <div className="row between-xs" id="total-cost">
                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                            {saleTaxValue ? (
                                                                <span id="total-cost-value">
                                                                    {packageDetails && cycle.selectedCycle == "annual"
                                                                        ? annualSalesTaxValue
                                                                            ? formatter.format(parseFloat(packageDetails.yearlySubscriptionPrice) + annualSalesTaxValue)
                                                                            : formatter.format(packageDetails.yearlySubscriptionPrice)
                                                                        : packageDetails && formatter.format(parseFloat(packageDetails.monthlySubscriptionPrice) + saleTaxValue)}
                                                                    /
                                                                    <abbr title="monthly">
                                                                        {packageDetails && cycle.selectedCycle == "annual"
                                                                            ? tLang("registration.plan.perYearText")
                                                                            : tLang("registration.plan.perMonthText")}
                                                                    </abbr>
                                                                </span>
                                                            ) : (
                                                                <span id="total-cost-value">
                                                                    {packageDetails && cycle.selectedCycle == "annual"
                                                                        ? formatter.format(packageDetails.yearlySubscriptionPrice)
                                                                        : packageDetails && formatter.format(packageDetails.monthlySubscriptionPrice)}
                                                                    /
                                                                    <abbr title="monthly">
                                                                        {packageDetails && cycle.selectedCycle == "annual"
                                                                            ? tLang("registration.plan.perYearText")
                                                                            : tLang("registration.plan.perMonthText")}
                                                                    </abbr>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {!!!SubType && LookupType === "SSSOFFER" && (
                                                <div className="row between-xs" id="total-cost">
                                                    <div className="col-xs col-no-gutter flex-grow-null">
                                                        {saleTaxValue ? (
                                                            <span id="total-cost-value">
                                                                {formatter.format(parseFloat(billingOptions?.cartPrice?.discountedPackagePrice) + saleTaxValue)}/
                                                                <abbr title="monthly">{tLang("registration.plan.perMonthText")}</abbr>
                                                            </span>
                                                        ) : (
                                                            <span id="total-cost-value">
                                                                {formatter.format(billingOptions?.cartPrice?.discountedPackagePrice)}/
                                                                <abbr title="monthly">{tLang("registration.plan.perMonthText")}</abbr>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="margin-bottom-s"></div>

                            <p>
                                <span className="default_link" onClick={() => setDialog(true)}>
                                    <a href="javascript:void(0)" className="default_link">
                                        {tLang("registration.plan.included-link")}
                                    </a>
                                </span>
                            </p>
                        </div>
                        {istermExiprationVisible ?
                            <div className="margin-bottom-s">
                                <span className="terms-exp">
                                    *Term expiration is {termExpirationServiceDuration} months from registration
                                </span>
                            </div> : ""}
                        {(LookupType === "SSSOFFER"
                            ? !!SubType && displayData.billingRequired && billingOptions.supportedBillingType && billingOptions.supportedBillingType.length > 1
                            : LookupType !== "SSSOFFER" &&
                            displayData.billingRequired &&
                            billingOptions.supportedBillingType &&
                            billingOptions.supportedBillingType.length > 1) && (
                                <div className="shopping-cart-billing">
                                    <h4 className="your-title">{tLang("registration.plan.billingCycle")}:</h4>

                                    <div className="selectBillingCycle">
                                        <legend className="sr-only">Select Billing Cycle Period</legend>
                                        {packageDetails.monthlySubscriptionPrice > 0 && (
                                            <div className="form-row no-margin">
                                                <div className="form-input">
                                                    <label className="form-radio-label" htmlFor="billing-cycle-monthly">
                                                        <input
                                                            type="radio"
                                                            onClick={() => setBillingCycle("monthly")}
                                                            id="billing-cycle-monthly"
                                                            name="billing-cycle"
                                                            defaultValue="monthly"
                                                            defaultChecked={cycle.selectedCycle === "monthly"}
                                                        />
                                                        <span className="form-radio-label-text">
                                                            {tLang("registration.plan.monthly")}{" "}
                                                            {/*<span className="billing-price" id="billing-price-monthly">*/}
                                                            {/*    {packageDetails && formatter.format(packageDetails.monthlySubscriptionPrice)}/*/}
                                                            {/*    <abbr title="monthly">{tLang("registration.plan.perMonthText")}</abbr>*/}
                                                            {/*</span>*/}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}

                                        {packageDetails.yearlySubscriptionPrice > 0 && (
                                            <div className="form-row no-margin">
                                                <div className="form-input">
                                                    <label className="form-radio-label" htmlFor="billing-cycle-anual">
                                                        <input
                                                            type="radio"
                                                            onClick={() => setBillingCycle("annual")}
                                                            id="billing-cycle-anual"
                                                            name="billing-cycle"
                                                            defaultValue="annual"
                                                            defaultChecked={cycle.selectedCycle === "annual"}
                                                        />
                                                        <span className="form-radio-label-text">
                                                            {tLang("registration.plan.annual")}{" "}
                                                            {/*<span className="billing-price" id="billing-price-annual">*/}
                                                            {/*    {packageDetails && formatter.format(packageDetails.yearlySubscriptionPrice)}/*/}
                                                            {/*    <abbr title="year">{tLang("registration.plan.perYearText")}</abbr>*/}
                                                            {/*</span>*/}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="margin-bottom-xs"></div>
                                    {billingOptions && billingOptions["billingCycleAnnualDescription"] && (
                                        <div className="msg-generic msg-no-icon msg-small">
                                            <p>{billingOptions && billingOptions["billingCycleAnnualDescription"]}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        {LookupType != "SSSOFFER" && saleTaxValue ? (
                            <div className="shopping-cart-footer padding-bottom-s">
                                <div className="row between-xs" id="plan-cost">
                                    <div className="col-xs col-no-gutter">{tLang("registration.plan.plan-cost")}:</div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <span id="plan-cost-value">
                                            {cycle.selectedCycle == "annual"
                                                ? billingOptions?.cartPrice?.annualPrice
                                                    ? formatter.format(billingOptions?.cartPrice?.annualPrice)
                                                    : " "
                                                : formatter.format(billingOptions?.cartPrice?.monthlyPrice)}
                                        </span>{" "}
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {LookupType != "SSSOFFER" && saleTaxValue ? (
                            <div className="shopping-cart-footer padding-bottom-s">
                                <div className="row between-xs" id="sales-tax">
                                    <div className="col-xs col-no-gutter">Sales Tax:</div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <span id="sales-tax-value">
                                            {cycle.selectedCycle == "annual"
                                                ? annualSalesTaxValue
                                                    ? formatter.format(annualSalesTaxValue)
                                                    : " "
                                                : formatter.format(saleTaxValue)}
                                        </span>{" "}
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        {LookupType === "SSSOFFER" && (
                            <div className="shopping-cart-footer sss-cart-footer">
                                {billingOptions?.cartPrice?.discount != 0 &&
                                    !isEBpartner &&
                                    !isReachpartner &&
                                    !isCyberscoutInsuPartner &&
                                    !isGuardWell &&
                                    !isGuardWellDiscount &&
                                    !isGuardWellPremier &&
                                    !!!SubType && (
                                        <>
                                            <div className="row between-xs" id="total-cost">
                                                <div className="col-xs col-no-gutter">{tLang("registration.plan.plan-cost")}:</div>
                                                <div className="col-xs col-no-gutter flex-grow-null strike-through">
                                                    <span id="total-strike-cost-value">{formatter.format(billingOptions?.cartPrice?.monthlyPrice)}</span>
                                                </div>
                                            </div>
                                            <div className="margin-bottom-xs"></div>
                                        </>
                                    )}
                                {billingOptions?.cartPrice?.discountedPackagePrice != 0 &&
                                    billingOptions?.cartPrice?.discount != 0 &&
                                    !isEBpartner &&
                                    !isCyberscoutInsuPartner &&
                                    !isGuardWell &&
                                    !isGuardWellDiscount &&
                                    !isGuardWellPremier &&
                                    !!!SubType && (
                                        <>
                                            <div className="row between-xs" id="total-cost">
                                                <div className="col-xs col-no-gutter">You Save:</div>
                                                <div className="col-xs col-no-gutter flex-grow-null ">
                                                    <span id="total-cost-discount-value">{formatter.format(billingOptions?.cartPrice?.discount)}</span>
                                                </div>
                                            </div>
                                            <div className="margin-bottom-xs"></div>
                                        </>
                                    )}
                                {saleTaxValue ? (
                                    <div className="shopping-cart-footer padding-bottom-s">
                                        <div className="row between-xs" id="sales-tax">
                                            <div className="col-xs col-no-gutter">Sales Tax:</div>
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <span id="sales-tax-value">
                                                    {cycle.selectedCycle == "annual"
                                                        ? annualSalesTaxValue
                                                            ? formatter.format(annualSalesTaxValue)
                                                            : " "
                                                        : formatter.format(saleTaxValue)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                {cycle.selectedCycle === "annual" && !saleTaxValue && (
                                    <>
                                        <div className="row between-xs" id="total-cost">
                                            <div className="col-xs col-no-gutter"></div>
                                        </div>
                                        <div className="margin-bottom-xs"></div>
                                    </>
                                )}
                                {!!!SubType && billingOptions?.cartPrice?.discountedPackagePrice == 0 && (
                                    <div className="row between-xs" id="total-cost">
                                        <div className="col-xs col-no-gutter">Total Cost:</div>
                                        <div className="col-xs col-no-gutter flex-grow-null">
                                            {saleTaxValue ? (
                                                <span id="total-cost-value">
                                                    {formatter.format(parseFloat(billingOptions?.cartPrice?.discountedPackagePrice) + saleTaxValue)}/
                                                    <abbr title="monthly">{tLang("registration.plan.perMonthText")}</abbr>
                                                </span>
                                            ) : (
                                                <span id="total-cost-value">
                                                    {formatter.format(billingOptions?.cartPrice?.discountedPackagePrice)}/
                                                    <abbr title="monthly">{tLang("registration.plan.perMonthText")}</abbr>
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {packageDetails && displayData.billingRequired && (
                            <div className={LookupType === "WALKUP" && displayData.billingRequired && billingOptions.supportedBillingType && billingOptions.supportedBillingType.length == 1 ? "border-bottom box-content" : "box-content"} >
                                <p className=" disclosure-content">
                                    {tLang("registration.plan.planChargeMsg1")}{" "}
                                    {cycle.selectedCycle === "annual" ? tLang("registration.plan.anAnnual") : tLang("registration.plan.aMonthly")}{" "}
                                    {tLang("registration.plan.planChargeMsg2")}
                                </p>
                            </div>
                        )}
                    </div>
                    {!isWhiteLabeled && <div style={{marginBottom:"16px"} }></div>}
                    <div className="cardDisclosure" style={{ lineHeight: "1.5rem", paddingTop: "20px", paddingBottom: "25px" }} dangerouslySetInnerHTML={{ __html: creditDisclosureText as string }}>
                    </div>
                </div>
            </div>
            {dialog && (
                <DialogComponent dialogId="whatsIncluded" title="Your cart" closeDialog={handleCloseDialog}>
                    <RegistrationPlanInfoDialog
                        packageName={getPackageOrOfferName()}
                        idfOfferLookup={idfOfferLookup}
                        packageLookup={displayData.packageLookup}
                    ></RegistrationPlanInfoDialog>
                </DialogComponent>
            )}
        </>
    );
};

export default Cart;
